import { DEFAULT_LOCALE } from "../constants";
import { locales } from "../lib";
import type { Locale } from "../types";

type GetLocaleFromPathProps = { path: string };

export const getLocaleFromPath = ({
  path,
}: GetLocaleFromPathProps): {
  locale: Locale;
  path: string;
} => {
  const [, potentialLocale, ...rest] = path.split("/");

  if (locales.includes(potentialLocale as Locale))
    return {
      locale: potentialLocale as Locale,
      path: rest.length === 0 ? "/" : `/${rest.join("/")}`,
    };

  return {
    locale: DEFAULT_LOCALE,
    path: path === "/" ? "/" : path,
  };
};
